import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Linkedin, Instagram } from 'lucide-react';
import { contactInfo } from '../data/mockData';
import { useLanguage } from '../contexts/LanguageContext';

export const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img src="/images/pura-logo.png" alt="PURA Ukraine" className="h-10 w-10" />
              <div className="flex flex-col">
                <span className="text-xl font-bold" style={{ color: 'rgb(1, 157, 180)' }}>PURA</span>
                <span className="text-xs">Ukraine</span>
              </div>
            </div>
            <p className="text-sm mb-4">
              {t('footer.description')}
            </p>
            <div className="flex space-x-4">
              <a href={contactInfo.social.facebook} target="_blank" rel="noopener noreferrer" className="hover:text-[rgb(1,157,180)] transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href={contactInfo.social.instagram} target="_blank" rel="noopener noreferrer" className="hover:text-[rgb(1,157,180)] transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm hover:text-[rgb(1,157,180)] transition-colors">
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-sm hover:text-[rgb(1,157,180)] transition-colors">
                  {t('nav.solutions')}
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-sm hover:text-[rgb(1,157,180)] transition-colors">
                  {t('nav.products')}
                </Link>
              </li>
              <li>
                <Link to="/partners" className="text-sm hover:text-[rgb(1,157,180)] transition-colors">
                  {t('nav.partners')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.ourProducts')}</h3>
            <ul className="space-y-2">
              <li className="text-sm">Станції біологічної очистки PURA</li>
              <li className="text-sm">PURA-4, PURA-6, PURA-9</li>
              <li className="text-sm">Монтаж під ключ та сервіс</li>
              <li className="text-sm">Нестандартні пластикові вироби</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.contacts')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <Phone className="h-4 w-4 mt-1 flex-shrink-0" style={{ color: 'rgb(1, 157, 180)' }} />
                <div className="flex flex-col space-y-1">
                  {contactInfo.phones.map((phone, index) => (
                    <a key={index} href={`tel:${phone.link}`} className="text-sm hover:text-[rgb(1,157,180)] transition-colors">
                      {phone.number}
                    </a>
                  ))}
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <Mail className="h-4 w-4 mt-1 flex-shrink-0" style={{ color: 'rgb(1, 157, 180)' }} />
                <a href={`mailto:${contactInfo.email}`} className="text-sm hover:text-[rgb(1,157,180)] transition-colors">
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 mt-1 flex-shrink-0" style={{ color: 'rgb(1, 157, 180)' }} />
                <span className="text-sm">{contactInfo.address}</span>
              </li>
            </ul>
            <p className="text-xs mt-4 text-gray-400">{contactInfo.workingHours}</p>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} {t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};